import { Box, Flex, Heading, HStack, SegmentGroup } from '@vesyl/ui/chakra'
import { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'

export default function () {
  const location = useLocation()
  const navigate = useNavigate()

  // Determine current tab from URL
  const currentTab = location.pathname.includes('/general') ? 'general' : 'template'
  const [value, setValue] = useState(currentTab)

  // Sync tab with URL
  useEffect(() => {
    setValue(currentTab)
  }, [currentTab])

  const handleValueChange = (details: { value: string | null }) => {
    if (!details.value) return
    setValue(details.value)
    navigate(details.value === 'general' ? 'general' : 'template')
  }

  return (
    <Box h="full" display="flex" flexDirection="column">
      <HStack p="6" pb="6" gap="3">
        <Heading as="h2" size="xl" mb="0" flex="1">
          Packing slips
        </Heading>
        <Flex justify={{ base: 'end', lg: 'center' }} flex="1" mx="auto">
          <SegmentGroup.Root size="xs" value={value} onValueChange={handleValueChange}>
            <SegmentGroup.Indicator />
            <SegmentGroup.Items
              items={[
                { value: 'general', label: 'General' },
                { value: 'template', label: 'Template' },
              ]}
            />
          </SegmentGroup.Root>
        </Flex>
        <Box w="24" h="1" flex="1" hideBelow="lg" />
      </HStack>

      <Box flex="1" minH="0" overflow="hidden">
        <Outlet />
      </Box>
    </Box>
  )
}
